// #region IMPORT
import { Box, Stack, Container, Typography } from '@mui/material';
// #endregion

interface Props {
  onOpenRegisterForm: (value: boolean) => void;
}

const overviewCards = [
  {
    type: 'zalo',
    title: 'Tích hợp zalo cá nhân',
    description: 'Tích hợp đa nền tảng, kết nối đồng bộ và chăm sóc khách hàng liền mạch',
    image: '/assets/landing/overview/zalo.png',
    background: '#050520',
    color: '#FFFFFF',
    border: 'none',
  },
  {
    type: 'platform',
    title: 'Nền tảng toàn diện',
    description: 'Quản lý - Giảng dạy - Học tập - Trợ lý AI Tất cả trong một nền tảng duy nhất',
    image: '/assets/landing/overview/platform.png',
    background: '#050505',
    color: '#FFFFFF',
    border: 'none',
  },
  {
    type: 'material',
    title: 'Học liệu số đa dạng',
    description: 'Được xây dựng dựa trên các Bộ giáo trình phổ biến từ các nhà xuất bản nổi tiếng.',
    image: '/assets/landing/overview/material.png',
    background: '#FFFFFF',
    color: '#252B36',
    border: '2px solid #9BD6FF',
  },
];

export const Overview = ({ onOpenRegisterForm }: Props) => {
  void onOpenRegisterForm;

  return (
    <Box
      component="section"
      sx={{
        py: {
          xs: 4,
          md: 6,
        },
      }}
    >
      <Container>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'minmax(0, 1fr)',
              md: 'repeat(3, minmax(0, 1fr))',
            },
            justifyItems: {
              xs: 'center',
              md: 'stretch',
            },
            gap: {
              xs: 2,
              sm: 3,
              md: 1.5,
              lg: 2,
            },
          }}
        >
          {overviewCards.map((card) => {
            const isMaterial = card.type === 'material';

            return (
              <Stack
                key={card.type}
                sx={{
                  position: 'relative',
                  overflow: 'hidden',
                  width: '100%',
                  minWidth: 0,
                  boxSizing: 'border-box',

                  maxWidth: {
                    xs: 520,
                    sm: 680,
                    md: 'none',
                  },

                  // Mobile tự cao theo nội dung.
                  // Tablet và desktop vẫn giữ tỷ lệ card.
                  aspectRatio: {
                    xs: 'auto',
                    sm: '4 / 5',
                    md: '304 / 412',
                  },

                  borderRadius: {
                    xs: '16px',
                    sm: '20px',
                  },

                  color: card.color,
                  background: card.background,
                  border: card.border,

                  boxShadow: isMaterial ? '0 2px 6px rgba(15, 23, 42, 0.12)' : 'none',
                }}
              >
                <Stack
                  spacing={{
                    xs: 0.75,
                    sm: 1,
                    md: 0.75,
                  }}
                  sx={{
                    position: 'relative',
                    zIndex: 2,
                    flexShrink: 0,
                    boxSizing: 'border-box',

                    px: {
                      xs: 2.5,
                      sm: 3,
                      md: 2,
                      lg: 3,
                    },

                    pt: {
                      xs: 2.5,
                      sm: 3,
                      md: 2,
                      lg: 3,
                    },

                    pb: {
                      xs: 1.5,
                      sm: 1.5,
                      md: 1,
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 700,
                      lineHeight: 1.2,
                      fontSize: {
                        xs: 20,
                        sm: 25,
                        md: 18,
                        lg: 24,
                      },
                    }}
                  >
                    {card.title}
                  </Typography>

                  <Typography
                    sx={{
                      fontWeight: 400,
                      lineHeight: 1.4,
                      fontSize: {
                        xs: 13,
                        sm: 15,
                        md: 12,
                        lg: 16,
                      },
                    }}
                  >
                    {card.description}
                  </Typography>
                </Stack>

                <Box
                  sx={{
                    position: 'relative',
                    flex: {
                      xs: 'none',
                      sm: 1,
                    },
                    minHeight: 0,
                    overflow: 'hidden',
                  }}
                >
                  <Box
                    component="img"
                    src={card.image}
                    alt={card.title}
                    sx={{
                      position: {
                        xs: 'relative',
                        sm: 'absolute',
                      },

                      display: 'block',

                      left: {
                        xs: 'auto',
                        sm: '50%',
                      },

                      bottom: {
                        xs: 'auto',
                        sm: 0,
                      },

                      width: {
                        xs: card.type === 'zalo' ? '108%' : isMaterial ? '110%' : '100%',
                        sm: isMaterial ? '108%' : '100%',
                        md: isMaterial ? '112%' : '100%',
                      },

                      height: {
                        xs: 'auto',
                        sm: isMaterial ? '108%' : '100%',
                        md: isMaterial ? '112%' : '100%',
                      },

                      objectFit: {
                        xs: 'initial',
                        sm: 'contain',
                      },

                      objectPosition: {
                        xs: 'center',
                        sm: 'center bottom',
                      },

                      mt: {
                        xs:
                          card.type === 'zalo' ? '-18%' : card.type === 'platform' ? '-6%' : '-4%',
                        sm: 0,
                      },

                      transform: {
                        sm: 'translateX(-50%)',
                      },

                      transformOrigin: {
                        xs: 'center',
                        sm: 'center bottom',
                      },

                      userSelect: 'none',
                      pointerEvents: 'none',
                    }}
                  />
                </Box>
              </Stack>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};
